// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"378":"4ef2e8e9","453":"670e15c7","674":"c70c352e"}[chunkId] + ".chunk.js";
};